
const CustomFieldRoutes = [
    {
        path: '',
        name: 'custom-field-index',
        component: () => import("@/components/admin/custom-field/list.vue"),
    },
    {
        path: 'list',
        name: 'list-custom-field',
        component: () => import("@/components/admin/custom-field/list.vue"),
    },
    {
        path: 'form',
        name: 'form-custom-field',
        component: () => import("@/components/admin/custom-field/form.vue"),
    }
];
export default CustomFieldRoutes